import { render, staticRenderFns } from "./HandoverOverview.vue?vue&type=template&id=c8e3ad1c"
import script from "./HandoverOverview.vue?vue&type=script&lang=js"
export * from "./HandoverOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports